import { useEffect, useRef, useState } from "react";
import { motion, useInView } from "framer-motion";
import { useTranslation } from "react-i18next";

function Counter({ value, suffix }: { value: number; suffix: string }) {
  const ref = useRef<HTMLSpanElement>(null);
  const inView = useInView(ref, { once: true, margin: "-50px" });
  const [n, setN] = useState(0);

  useEffect(() => {
    if (!inView) return;
    const duration = 1400;
    const start = performance.now();
    let raf = 0;
    const step = (t: number) => {
      const p = Math.min(1, (t - start) / duration);
      setN(Math.round(value * (1 - Math.pow(1 - p, 3))));
      if (p < 1) raf = requestAnimationFrame(step);
    };
    raf = requestAnimationFrame(step);
    return () => cancelAnimationFrame(raf);
  }, [inView, value]);

  return (
    <span ref={ref}>
      {n}
      {suffix}
    </span>
  );
}

export default function StatsBar() {
  const { t } = useTranslation("landing");

  const stats = [
    { value: 10, suffix: "", label: t("statsBar.stats.0.label") },
    { value: 10, suffix: "", label: t("statsBar.stats.1.label") },
    { value: 25, suffix: "+", label: t("statsBar.stats.2.label") },
    { value: 0, suffix: "LOA", label: t("statsBar.stats.3.label"), text: true },
  ];

  return (
    <section className="bg-blue-bg py-14 w-full">
      <div className="mx-auto w-full grid max-w-7xl grid-cols-2 gap-8 px-4 sm:px-6 text-center lg:grid-cols-4 lg:px-8">
        {stats.map((s, i) => (
          <motion.div
            key={i}
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: i * 0.08 }}
          >
            <div className="text-5xl font-extrabold text-navy sm:text-6xl">
              {s.text ? "LOA" : <Counter value={s.value} suffix={s.suffix} />}
            </div>
            <div className="mt-2 text-sm font-semibold text-slate-body">{s.label}</div>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
